import React, {useState, useEffect, useCallback} from "react";
import {defineBlock, smartProps, SmartForm, useSmartProp, useInspectorControl} from "@smartfire/gutenberg-react";
import { PanelBody, PanelRow, SelectControl, TextControl, TextareaControl } from '@wordpress/components';
import LinearProgress from '@material-ui/core/LinearProgress';
import { makeStyles } from '@material-ui/core/styles';
import apiFetch from '@wordpress/api-fetch';
import style from './block.module.scss';
import 'leaflet/dist/leaflet.css';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet'
import L from 'leaflet';
import icon from 'leaflet/dist/images/marker-icon.png';
import iconShadow from 'leaflet/dist/images/marker-shadow.png';


const useStyles = makeStyles((theme) => ({
  root: {
      backgroundColor: "rgba(41, 50, 134, .3)",
  },
  bar: {
      backgroundColor: "#293286",
  },
}));
 


function Inspector () {
    const listForms = window.keysFields;
    const [idForm, setIdForm] = useSmartProp('idForm');
    const [adresse1, setAdresse1] = useSmartProp('adresse1');
    const [adresse2, setAdresse2] = useSmartProp('adresse2');
    const [tel, setTel] = useSmartProp('tel');
    const [latitude, setLatitude] = useSmartProp('latitude');
    const [longitude, setLongitude] = useSmartProp('longitude');
    const [mapsLink, setMapsLink] = useSmartProp('mapsLink');

    return <>
     <PanelBody title="Formulaire" initialOpen={true}>
        <PanelRow>
            <SelectControl
                label="Formulaire"
                value={idForm || window.keysFields[0]}
                onChange={value => setIdForm(value)}
                options={listForms}
            />
        </PanelRow>
    </PanelBody>
    <PanelBody title="Coordonnées" initialOpen={true}>
        <PanelRow>
            <TextareaControl
                label="Adresse (ligne 1)"
                value={adresse1}
                onChange={value => setAdresse1(value)}
            />
        </PanelRow>
         <PanelRow>
            <TextareaControl
                label="Adresse (ligne 2)"
                value={adresse2}
                onChange={value => setAdresse2(value)}
            />
        </PanelRow>
        <PanelRow>
            <TextControl
                label="Téléphone"
                value={tel}
                onChange={value => setTel(value)}
            />
        </PanelRow>
        <PanelRow>
            <TextControl
                label="Latitude"
                value={latitude}
                type="number"
                onChange={value => setLatitude(Number(value))}
            />
        </PanelRow>
        <PanelRow>
            <TextControl
                label="Longitude"
                value={longitude}
                type="number"
                onChange={value => setLongitude(Number(value))}
            />
        </PanelRow>
        <PanelRow>
            <TextControl
                label="Lien Maps"
                value={mapsLink}
                onChange={value => setMapsLink(value)}
            />
        </PanelRow>
    </PanelBody>
    </>
}


function Block({idForm, adresse1, adresse2, tel, latitude, longitude, mapsLink}){
    useInspectorControl(Inspector);
    const [isLoading, setIsLoading] = useState(false);
    const classes = useStyles();
    const [msg, setMsg] = useState("");
    const [isMsgError, setIsMsgError] = useState(false);
    let DefaultIcon = L.icon({
        iconUrl: icon,
        shadowUrl: iconShadow,
        iconSize: [24,36],
        iconAnchor: [12,36]
    });

    L.Marker.prototype.options.icon = DefaultIcon;
    const onSubmit = (e) => {
        e.preventDefault();

        let values = {};
        const formElements = e.target.elements;
        for(let i = 0; i < formElements.length; i++) {
           const elmt = formElements[i];
           if(elmt.tagName !== "BUTTON") {
               if(elmt.type === "checkbox") {
                   values[elmt.name] = elmt.checked ? "1" : "0";
               }
               else {
                   if(elmt.required !== false || elmt.value !== "") values[elmt.name] = elmt.value;
               }
           }
        }

        setIsLoading(true)
        apiFetch({
            path: "/smartfire-contact-form/v1/form/",
            method: "POST",
            data: values,
        }).then((data) => {
            setIsLoading(false);
            setIsMsgError(false);
            setMsg(data);
        }, err => {
            setIsLoading(false);
            setIsMsgError(true);
            setMsg(err.message);
        });

    }

    const Hidden = () => (
        <input type="hidden" id="id_form" name="id_form" value={idForm} />
    )

    const Message = () => (
        <div className={style.returnMessage}>
            {
                isLoading ?
                    <LinearProgress classes={{
                        root: classes.root,
                        bar: classes.bar,
                    }} />
                    :
                    (msg && typeof msg === 'string') ? <div className={isMsgError ? style.error : style.success}>{msg}</div> : ""
            }
        </div>
    )
    const handleInputActive = useCallback((event, input)=>{
        const label = input.children[3].children[0].children[0];
        if (event.target.value.length > 0) {
            if (!label.classList.contains('active')) {
                label.classList.add("active");
            }
        } else {
            if (label.classList.contains('active')) {
                label.classList.remove("active");
            }
        }
    }, [])
    
    useEffect(() => {
        setTimeout(()=>{
            const inputs = document.querySelector("#contactForm").querySelectorAll('.wp-block-smartfire-input, .wp-block-smartfire-textarea' );
            Array.from(inputs).slice(0, 5).map(input => 
                input.addEventListener('change', (e) => handleInputActive(e, input))
            );
        }, 1000)
        return () =>{
            const inputs = document.querySelector('#contactForm').querySelectorAll('.wp-block-smartfire-input, .wp-block-smartfire-textarea' );
                Array.from(inputs).slice(0, 5).map(input => 
                input.removeEventListener('change', (e) => handleInputActive(e, input))
            );
        } 
    }, [handleInputActive]);

    return <div className={style.block + " "+style.wrapper}>
                <div className={style.background}>
                    <div className={style.left}/>
                    <div/>
                </div>
                <div className={style.grid} id={"contactForm"}>
                    <div className={style.left}>
                        <h2>Nous contacter<span className={style.dot}>.</span></h2>
                        <h5>Adresse</h5>
                        <div className={style.adresse} dangerouslySetInnerHTML={{__html: adresse1}} />
                        <div className={style.adresse} dangerouslySetInnerHTML={{__html: adresse2}} />
                        <h5>Téléphone</h5>
                        <a href={"tel:"+tel} className={style.telephone} dangerouslySetInnerHTML={{__html: tel}} />
                        <MapContainer center={[latitude, longitude]} zoom={13} scrollWheelZoom={true} className={style.map}>
                            <TileLayer
                                attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                            />
                            <Marker position={[latitude, longitude]}>
                                <Popup>
                                    <a href={mapsLink} rel="noopener noreferrer" target="_blank">voir sur Maps</a>
                                </Popup>
                            </Marker>
                        </MapContainer>
                    </div>
                    <SmartForm
                        className={style.form}
                        onSubmit={onSubmit}
                        smartProp="buttonText"
                        idForm={idForm}>
                        <Hidden />
                        <Message />
                    </SmartForm>
                </div>
    </div>

}

export default defineBlock({
    Block,
    smartProps:{
        buttonText: smartProps.string.withDefault('Envoyer'),
        idForm: smartProps.string.withDefault('contact'),
        latitude: smartProps.number.withDefault(0),
        longitude: smartProps.number.withDefault(0),
        adresse1: smartProps.string.withDefault(''),
        adresse2: smartProps.string.withDefault(''),
        tel: smartProps.string.withDefault(''),
        mapsLink: smartProps.string.withDefault("")
    },
    setup: {
        title: "Formulaire de contact",
        category: "email",
    }
})
